import { css } from 'styled-components';

// Shared typography for rendered JD HTML content (p, h1-h6, ul, li, a).
// Mirrors styles.scss rules — apply to any container that renders raw JD HTML.
export const jdContentTypography = css`
  * {
    font-family:${p => p.theme?.typography?.fontFamily ?? "'Inter', sans-serif"}
    font-size: 14px;
    line-height: 16px;
  }

  p {
    font-weight: 500;
    color: ${p => p.theme?.colors?.dark ?? '#565E70'};
    margin: 0;
    padding: 0;
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: 500;
    color: ${p => p.theme?.colors?.dark ?? '#2B3034'};
    margin-bottom: 0;
  }

  ul, li {
    font-weight: 500;
    color: ${p => p.theme?.colors?.dark ?? '#565E70'};
  }

  a {
    font-weight: 500;
    color: ${p => p.theme?.colors?.info ?? '#0088CE'};
    text-decoration: none;
    cursor: pointer;

    &:hover, &:focus {
      color: ${p => p.theme?.colors?.primaryHover ?? '#006666'};
      text-decoration: none;
    }
  }
`;
